<nav class="navbar navbar-light bg-light">
    <span class="navbar-brand mb-0 h1">Simulator</span>

    
    <div *ngIf="paused">
        <button class="btn btn-primary" (click)="unpause()">Play</button>
    </div>
    <div *ngIf="!paused">
        <button class="btn btn-secondary" (click)="pause()">Pause</button>
    </div>
</nav>
  

<svg id="mapWrapper" style=" width: 100%; height: 80vh;"></svg>


<app-log-box 
    [numMsgsInCirculation]="numMsgsInCirculation"
    [curNodeDegree]="curNodeDegree"
    [simState]="simState"    
></app-log-box>

<footer class="footer">
    <div class="container-fluid">

        <div class="row">

            <div ngbDropdown class="d-inline-block pl-2 dropup" placement="top-left">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
                    {{ (selectedNodeToShowDetails) ? selectedNodeToShowDetails.id : 'Select Node' }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1"  style="max-height: 280px; overflow-y: auto;">
                  <button ngbDropdownItem *ngFor="let node of nodes" (click)="selectNodeToShowDetails(node)">
                      <div style="height:10px;width:10px;background-color:#{{ node.colour }} !important; display:inline-block !important;"></div>
                      {{ node.id }}
                    </button>
                </div>
            </div>

            <div class="d-inline-block pl-2" *ngIf="selectedNodeToShowDetails">
                <strong>Selected Node:</strong>&nbsp;<div style="height:10px;width:10px;background-color:#{{ selectedNodeToShowDetails.colour }} !important; display:inline-block !important;"></div> 
                {{selectedNodeToShowDetails.id }}<br>
                <strong>Messages: </strong> {{ selectedNodeToShowDetails.messagingSystem.messages }}
            </div>

        </div>
    </div>
</footer>


<ng-template #resultsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Results</h4>
      <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
    </div>
    <div class="modal-body">
        <table class="table">
            <thead>
                <tr>
                    <th>Metric</th>
                    <th>Result</th>
                </tr>
            </thead>
            <tbody>
                <tr><td>Simulation time: </td><td> {{ results!.simTime | number }}</td></tr>
                <tr><td>Messages Sent: </td><td>{{ results!.numUniqueMsgsSent | number }}</td></tr>
                <tr><td>Messages Delivered: </td><td>{{ results!.numMsgsReceived | number }}</td></tr>
                <tr><td>Messages Relayed: </td><td>{{ results!.numMsgsRelayed | number }}</td></tr>
                <tr><td>Messages Dropped: </td><td>{{ results!.numMsgsDropped | number }}</td></tr>

                <tr><td>Delivery Probability: </td><td>{{ results!.deliveryProbability | percent }}</td></tr>
                <tr><td>Latency Average: </td><td>{{ results!.avgLatency | number : '1.0-2' }}</td></tr>
                <tr><td>Hopcount Average: </td><td>{{ results!.avgHopCount | number : '1.0-2' }}</td></tr>
                <tr><td>Hopcount Median: </td><td>{{ results!.medHopCount }}</td></tr>

                <tr><td>Average Node Degree: </td><td>{{ results!.avgNodeDegree | number : '1.0-2' }}</td></tr>
                <tr><td>Overhead: </td><td>{{ results!.overhead | number : '1.0-2' }}</td></tr>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <!-- <div class="row"> -->
            <button type="button" class="btn btn-outline-dark mr-auto" (click)="returnHome()">Return to Menu</button>
            <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
        <!-- </div> -->
    </div>
</ng-template>